import type { FaireProductEntity } from "../../entity_types/product";

export const p_z6vektpr63: FaireProductEntity = {
  token: "p_z6vektpr63",
  type: "product",
  name: "christmas gifts gift wrapping paper",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl: "https://cdn.faire.com/fastly/c23b6488be3b64bb291dedd316d02ca90256838633a4a02ed61c9a2abdbe2e6f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab27d52c4bb44f36dc35773765dca54084fb86a773ae8bb46f80391257d37235.jpeg",
    "https://cdn.faire.com/fastly/9404ca2c62082e905e57f4fa46efaad887f2c4fe062fb16d3fb5ee952b05c7a9.jpeg",
    "https://cdn.faire.com/fastly/7b38b117cd767979d9202d598033c718100395e389bfa241ff871d96702380de.jpeg"
  ],
  priceDollars: 8.5,
  description: "Make your Christmas gifts extra lovely with decorative wrapping paper.\nPrinted on matte paper that’s just the right weight for crisp folds and smooth creases, each set includes three pre-cut sheets for easy wrapping. Perfect for adding a beautiful finishing touch to any present.\n\n• Three rolled sheets\n• 19 ¾\" x 28\"\n• 80lb matte paper",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:09.298Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
